import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  viewPathConstants,
  freelanceStatusEnum,
  subscriptionTypeConstants,
  roles,
  translationConstants,
} from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  paymentActions,
  instructorActions,
  SubscriptionActions,
} from "../../../redux/actions";
import BecomeFreelanceInstructorPayment from "../../../shared/components/Modals/BecomeFreelanceInstructorPayment";
import { allSharedComponents } from "../../../shared";
import { unloadWidget } from "../../../system";

const { GeneralLogo, BaseForm, CustomModal } = allSharedComponents;

const FreelanceRePayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isShowModal, setShowModal] = useState(false);
  const [vat, setVat] = useState();
  const [pricing, setPrice] = useState();
  const [priceBreakdown, setPriceBreakdown] = useState(null);

  const userData = useSelector((state) => state?.LoginReducer?.UserData);
  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const freelanceData = useSelector(
    (state) => state.InstructorReducer.freelanceInstructorSportsDetail
  );

  useEffect(() => {
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    dispatch(
      instructorActions.getFreelancerSportsDetail(userData?.instructorId)
    );
  }, []);

  useEffect(() => {
    const vatPercentage = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    )?.price;
    if (vatPercentage) setVat(vatPercentage);
    const filteredPrices = subscriptionPrices?.filter((x) => {
      const isMatchingSportId = freelanceData?.sportIds?.includes(
        x.subcriptionType
      );
      const isFreelancer = x.userType === roles?.FreelanceInstructor;
      return isMatchingSportId && isFreelancer;
    });
    const breakdownSports = filteredPrices?.map((x) => {
      const newFormat = { sport: x.subcriptionType, price: x.price };
      return newFormat;
    });
    const subTotal = filteredPrices.reduce((acc, item) => acc + item.price, 0);
    const vatPrice = (vatPercentage / 100) * subTotal;
    const totalPrice = vatPrice + subTotal;
    const pricingBreakdown = {
      sports: breakdownSports,
      subTotal: subTotal,
      vatPrice: vatPrice,
      vatPercentage: vatPercentage,
      totalPrice: totalPrice,
    };
    setPriceBreakdown(pricingBreakdown);
    setPrice(subTotal);
  }, [subscriptionPrices, freelanceData]);

  const showModalHandler = () => {
    setShowModal(true);
    dispatch(paymentActions.paymentCheckoutNull());
    unloadWidget();
    if (isShowModal === true) {
      navigate(viewPathConstants.PROFILE);
    }
  };

  useEffect(() => {
    if (
      userData?.freelanceStatus === freelanceStatusEnum.PaymentPending ||
      userData?.freelanceStatus === freelanceStatusEnum.PaymentRejected ||
      userData?.freelanceStatus === freelanceStatusEnum.Restricted
    ) {
      showModalHandler();
    } else {
      dispatch(paymentActions.paymentCheckoutNull());
      navigate(viewPathConstants.PROFILE);
    }
    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    if (userData) {
      dispatch(
        instructorActions.getFreelancerSportsDetail(userData?.instructorId)
      );
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="background-image">
        <CustomModal
          scrollable
          show={isShowModal}
          setShow={showModalHandler}
          size="sm"
          closeBtnClasses={"login-modal-close-btn"}
        >
          <BaseForm>
            <GeneralLogo />
            <BecomeFreelanceInstructorPayment
              title={t(translationConstants.FREELANCE_INSTRUCTOR_PAYMENT)}
              price={{ current: pricing }}
              vat={vat}
              sportIds={freelanceData?.sportIds}
              spotId={freelanceData?.spotId}
              pricingBreakdown={priceBreakdown}
            />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default FreelanceRePayment;
